import axios from "axios";
import Vue from "vue";

export default {
    state: () => ({
        seaTourList : null,
        seaTour : null,
        seaTourRouteList : null,
        seaTourRoute : null
    }),
    mutations: {
        setSeaTourList:function (state,seaTourList){
            state.seaTourList = seaTourList;
        },
        setSeaTour:function (state,seaTour){
            Vue.set(state,"seaTour", seaTour);
            // state.seaTour = seaTour
        },
        setSeaTourRouteList:function (state,seaTourRouteList){
            state.seaTourRouteList = seaTourRouteList;
        },
        setSeaTourRoute:function (state,seaTourRoute){
            state.seaTourRoute = seaTourRoute
        }
    },
    getters: {
        getSeaTourList : state => {
            return state.seaTourList
        },
        getSeaTour : state => {
            return state.seaTour
        },
        getSeaTourRouteList : state => {
            return state.seaTourRouteList
        },
        getSeaTourRoute : state => {
            return state.seaTourRoute
        }
    },
    actions:{
        loadSeaTourList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/seaTour",{headers})
                .then((response) => {
                    context.commit("setSeaTourList",response.data)
                    return response.data;
                })
        },
        loadSeaTour(context, id){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/seaTour/"+id,{headers})
                .then((response) => {
                    context.commit("setSeaTour",response.data)
                    return response.data;
                })
        },
        saveSeaTour(context, seaTour){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/seaTour",seaTour,{headers})
                .then((response) => {
                    context.commit("setSeaTour",response.data)
                    return response.data;
                })
        },
        updateSeaTour(context, seaTour) {
            let imageUrl = seaTour.imageUrl;

            if(seaTour.imageUrl.startsWith("http")){
                seaTour.imageUrl = null;
            }

            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.put(context.getters.getServiceUrl + "/admin-api/seaTour",seaTour,{headers})
                .then((response) => {
                    if(imageUrl.startsWith("http")){
                        seaTour.imageUrl = imageUrl;
                    }else{
                        seaTour.imageUrl = response.data.imageUrl;
                    }
                    context.commit("setSeaTour",seaTour)
                    return response.data;
                })
        },
        deleteSeaTour(context, seaTour){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.delete(context.getters.getServiceUrl + "/admin-api/seaTour/"+seaTour.id,{headers})
                .then((response) => {
                    let seaTourList = context.getters.getSeaTourList
                    seaTourList.splice(seaTourList.indexOf(seaTour), 1)
                    context.commit("setSeaTourList", seaTourList);

                    return response.data;
                })
        },

        // ROUTE

        loadSeaTourRouteListBySeaTourId(context, seaTourId){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/seaTour/"+seaTourId+"/route",{headers})
                .then((response) => {
                    context.commit("setSeaTourRouteList", response.data)

                    return response.data;
                })
        },
        saveSeaTourRoute(context, seaTourRoute){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/seaTour/route",seaTourRoute,{headers})
                .then((response) => {
                    this.commit("setSeaTourRoute", response.data)
                    return response.data;
                })
        },
        updateSeaTourRoute(context, seaTourRoute) {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.put(context.getters.getServiceUrl + "/admin-api/seaTour/route",seaTourRoute,{headers})
                .then((response) => {
                    context.commit("setSeaTourRoute", response.data)
                    return response.data;
                })
        },
        batchUpdateSeaTourRoute(context) {
            let seaTourList = context.getters.getSeaTourRouteList;

            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.put(context.getters.getServiceUrl + "/admin-api/seaTour/route/batch",seaTourList,{headers})
                .then((response) => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Başarılı',
                        text: '',
                    })
                    return response.data;
                })
        },
        deleteSeaTourRoute(context, seaTourRoute){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.delete(context.getters.getServiceUrl + "/admin-api/seaTour/route/"+seaTourRoute.id,{headers})
                .then((response) => {
                    let seaTourRouteList = context.getters.getSeaTourRouteList
                    seaTourRouteList.splice(seaTourRouteList.indexOf(seaTourRoute), 1)
                    context.commit("setSeaTourRouteList", seaTourRouteList);

                    return response.data;
                })
        },


    }
}